import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import AHRS from "../../assets/images/ahrs.png"

const AHRS_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={AHRS} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-width">
        <h2 className="spec-title">{t('accessoires.ahrs.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.ahrs.details.p1')}</li>
          <li>{t('accessoires.ahrs.details.p2')}</li>
          <li>{t('accessoires.ahrs.details.p3')}</li>
          <li>{t('accessoires.ahrs.details.p4')}</li>
          <li>{t('accessoires.ahrs.details.p5')}</li>
          <li>{t('accessoires.ahrs.details.p6')}</li>
          <li>{t('accessoires.ahrs.details.p7')}</li>
        </ul>
      </div>

    </div>
  );
};

export default AHRS_SPEC;
